import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import analytics from '../analytics';

const useGoogleAnalytics = () => {
    const { pathname, search } = useLocation();

    useEffect(() => {
        analytics.init();
    }, []);

    useEffect(() => {
        analytics.sendPageview(pathname + search);
    }, [pathname, search]);
};

export default useGoogleAnalytics;
